<template>
  <div>
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="tab"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #colStatus="{ row }">
        <el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">
          {{ row.status === 1 ? '启用' : '禁用' }}
        </el-tag>
      </template>
      <template #colPayinLimit="{ row }">
        <span>
          {{ centsToYuan(row.payin_min_amount) ?? '-' }} - {{ centsToYuan(row.payin_max_amount) ?? '-' }}
          {{ row.currency }}
        </span>
      </template>
      <template #colPayinFee="{ row }">
        {{ row.payin_fee_rate + '%' || '-' }}
      </template>
      <template #colActions="{ row }">
        <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
      </template>
    </SchemaTablePage>

    <PaymentChannelDialog
      :visible.sync="dialogVisible"
      :mode="dialogMode"
      channel-type="payin"
      :edit-id="editId"
      :edit-row="editRow"
      @success="handleDialogSuccess"
    />
  </div>
</template>

<script>
import { listPayinChannels } from '@/api/finance/paymentChannel'
import { centsToYuan, yuanToCents } from '@/utils/amount'
import PaymentChannelDialog from './PaymentChannelDialog.vue'
import SchemaTablePage from '@/components/SchemaTablePage'

export default {
  name: 'ManagePayinChannelTab',
  components: { PaymentChannelDialog, SchemaTablePage },
  data() {
    return {
      centsToYuan,
      yuanToCents,
      defaultQuery: {
        channel_name: '',
        status: '',
      },
      searchSchema: [
        {
          prop: 'channel_name',
          label: '通道名称',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'status',
          label: '通道状态',
          component: 'select',
          componentProps: { clearable: true },
          options: [
            { label: '全部', value: '' },
            { label: '启用', value: 1 },
            { label: '禁用', value: 2 },
          ],
        },
        { component: 'actions' },
      ],
      tableColumns: [
        { prop: 'channel_name', label: '通道名称', width: 120, resizable: false },
        { prop: 'status', label: '通道状态', width: 90, resizable: false, slot: 'colStatus' },
        { prop: 'currency', label: '支持币种', width: 90, resizable: false },
        { prop: 'payinLimit', label: '单笔限额', minWidth: 140, resizable: false, slot: 'colPayinLimit' },
        { prop: 'payinFee', label: '充值手续费', width: 100, resizable: false, slot: 'colPayinFee' },
        { prop: 'weight', label: '权重', width: 70, align: 'center', resizable: false },
        { prop: 'remark', label: '备注', minWidth: 100, resizable: false },
        {
          fixed: 'right',
          prop: 'action',
          label: '操作',
          width: 100,
          align: 'center',
          resizable: false,
          slot: 'colActions',
        },
      ],
      dialogVisible: false,
      dialogMode: 'create',
      editId: null,
      editRow: null,
    }
  },
  methods: {
    request(params) {
      return listPayinChannels(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
      }
      if (query.channel_name) params.channel_name = query.channel_name
      if (query.status !== '' && query.status != null) params.status = query.status
      return params
    },
    parseResult(res) {
      const data = (res && res.data) || res
      const rawList = (data && data.list) || (Array.isArray(data) ? data : [])
      const rawTotal = (data && data.total) != null ? data.total : rawList.length
      return {
        list: Array.isArray(rawList)
          ? rawList.map(e => {
              return {
                ...e,
                payin_fee_rate: this.formatFeeRate(e.payin_fee_rate),
              }
            })
          : [],
        total: rawTotal,
      }
    },
    formatFeeRate(feeRate) {
      if (feeRate == null || feeRate === '') return '-'
      const n = Number(feeRate)
      if (!Number.isFinite(n)) return '-'
      // 避免浮点误差（如 0.0035 * 100 -> 0.35000000000000003）
      const raw = (n * 100).toFixed(6)
      const trimmed = raw.replace(/\.?0+$/, '')
      return trimmed
    },
    handleEdit(row) {
      this.dialogMode = 'edit'
      this.editId = row.id
      this.editRow = row
      this.dialogVisible = true
    },
    handleDialogSuccess() {
      this.$refs.tablePageRef?.reload?.()
      this.$emit('update')
    },
  },
}
</script>
